import useMonolithApiMutation from '@/hooks/api/useMonolithApiMutation';
import { buildCacheSubscriptionPath } from '@/utils/monolithApiRouteService';

const useBuildCacheSubscriptionRequest = (workspaceSlug: string, source: string, onSuccess: () => void) => {
  const { mutate, isPending, isError } = useMonolithApiMutation(
    buildCacheSubscriptionPath(workspaceSlug, {
      params: {
        source,
      },
    }),
    'POST',
    {
      onSuccess: () => onSuccess(),
    },
  );

  return {
    submit: () => mutate(null),
    isPending,
    isError,
  };
};

export default useBuildCacheSubscriptionRequest;
